import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { PlatformService } from '@core/services/platform.service';

@Pipe({
    name: 'timeRemaining',
    standalone: true
})
export class TimeRemainingPipe implements PipeTransform {
    private inTime: boolean = true;

    constructor(private plataformService: PlatformService) {}

    public transform(
        secondsLeft?: number | Date,
        showCounter: boolean = false
    ): Observable<{ time: Date; onTimeForSameDayDelivery: boolean }> {
        let endDate = new Date(secondsLeft || 0);
        if (typeof secondsLeft === 'number') {
            endDate = new Date();
            endDate.setSeconds(endDate.getSeconds() + Math.round(secondsLeft) + 1);
        }

        // if the time is already over to show the count-down counter,
        // we need to show the hour until when the user can then buy with same-day delivery
        if (!showCounter || this.plataformService.isServer) {
            return of({ time: endDate, onTimeForSameDayDelivery: false });
        }

        // time remaining to over the same-day delivery
        return timer(0, 1000).pipe(
            takeWhile(_ => this.inTime),
            map(_ => {
                const currentTime = new Date();
                const finalDate = new Date(endDate);
                const diff = finalDate.getTime() - currentTime.getTime();
                const hours = finalDate.getHours() - currentTime.getHours();
                const min = finalDate.getMinutes() - currentTime.getMinutes();
                const sec = finalDate.getSeconds() - currentTime.getSeconds();
                if (diff <= 0) {
                    this.inTime = false;
                }

                return new Date(
                    currentTime.getFullYear(),
                    currentTime.getMonth(),
                    currentTime.getDate(),
                    hours,
                    min,
                    sec
                );
            }),
            map(time => ({ time: time, onTimeForSameDayDelivery: this.inTime }))
        );
    }
}
